import React from "react";
import { createPortal } from "react-dom";
import { CloseMapBtn as Styled } from "./index-styled";
import DenyIcon from "_c/icon/Deny";

const CloseMapBtn = (props) => {
  return createPortal(
    <Styled negative medium onClick={() => props.toggleMap()}>
      <DenyIcon width="13" color="white" />
    </Styled>,
    document.getElementById("root")
  );
};
export default CloseMapBtn;
